import { useState } from "react";

/**
 * Miniaturas das artes do pedido — junta as imagens dos itens (order_items)
 * e cai para a imagem global do pedido quando os itens não têm arte própria.
 * `hoverZoom`: ao passar o mouse, mostra a arte ampliada (300px) ao lado.
 */
export default function OrderThumbs({ order, sizePx = 40, max = 4, dark = false, hoverZoom = false, testid }) {
  const [zoomIdx, setZoomIdx] = useState(null);
  const urls = [];
  for (const it of order.order_items || []) if (it.image_url) urls.push(it.image_url);
  if (urls.length === 0 && order.image_url) urls.push(order.image_url);
  if (urls.length === 0) return null;
  const shown = urls.slice(0, max);
  return (
    <div className="flex items-center gap-1.5 flex-wrap" data-testid={testid}>
      {shown.map((u, i) => (
        <div
          key={`${u}-${i}`}
          className="relative"
          onMouseEnter={() => hoverZoom && setZoomIdx(i)}
          onMouseLeave={() => hoverZoom && setZoomIdx(null)}
        >
          <img
            src={u}
            alt={`arte ${i + 1}`}
            loading="lazy"
            className={`object-contain bg-white border ${dark ? "border-white/30" : "border-zinc-300"}`}
            style={{ width: sizePx, height: sizePx }}
          />
          {zoomIdx === i && (
            <img
              src={u}
              alt={`arte ${i + 1} ampliada`}
              className={`absolute right-full top-0 mr-2 z-50 shadow-2xl border-2 bg-white ${dark ? "border-white/50" : "border-black"}`}
              style={{ height: 500, width: "auto", maxWidth: 850, objectFit: "contain" }}
              data-testid={`${testid}-zoom`}
            />
          )}
        </div>
      ))}
      {urls.length > max && (
        <span className={`text-[10px] font-mono ${dark ? "text-white/50" : "text-zinc-400"}`}>+{urls.length - max}</span>
      )}
    </div>
  );
}
